export const VIEWABLE_SIZE_LIMIT_5MB = 5 * 1024 * 1024;

export const VIEWABLE_SUPPORTED_FILE_TYPES = [
  'image/gif',
  'image/jpeg',
  'image/png',
  'text/plain',
  'text/csv',
  'text/markdown',
  'text/tab-separated-values',
  'text/yaml',
  'application/json',
  'application/xml',
  'application/pdf',
  'application/x-ipynb+json',
  'application/cwl',
];

export const VIEWABLE_SUPPORTED_FILE_EXTS = ['.ipynb', '.cwl', '.hl7', '.grl'];

export const canRender = (file: any) =>
  VIEWABLE_SUPPORTED_FILE_TYPES.some(prefix =>
    file.contentType.startsWith(prefix),
  ) || VIEWABLE_SUPPORTED_FILE_EXTS.some(ext => file.name.endsWith(ext));
